export const ACTIONS_ELECTION_RESULT_ANALYTICS = {
	ELECTION_RESULT_ANALYTICS: 'election_result_analytics',
	ELECTION_RESULT_ANALYTICS_VIEW: 'election_result_analytics_view',
} as const;
